import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Home, Phone } from "lucide-react";
import SEO from "@/components/SEO";
import { WHATSAPP_URL as WHATSAPP_LINK, PHONE_DISPLAY } from "@/constants/contact";

const POPULAR_LINKS = [
  { label: "Rhinoplasty (Nose Surgery)", to: "/rhinoplasty-in-mumbai" },
  { label: "Breast Implant Surgery", to: "/breast-implant-surgery-mumbai" },
  { label: "Liposuction", to: "/liposuction-surgery-mumbai" },
  { label: "Facelift Surgery", to: "/facelift-surgery-mumbai" },
  { label: "Gynecomastia Surgery", to: "/gynecomastia-surgery-mumbai" },
  { label: "Hair Transplant", to: "/hair-transplant-mumbai" },
];

const NotFoundPage = () => {
  return (
    <>
      <SEO
        title="Page Not Found (404)"
        description="The page you're looking for doesn't exist. Explore our cosmetic and reconstructive surgery procedures or contact Dr. Vicky Jain's clinic in Mumbai."
        robots="noindex, follow"
      />
      <section className="bg-warm-white pt-28 pb-20 md:pt-36 md:pb-28" data-testid="not-found-section">
        <div className="container mx-auto px-4 md:px-8 max-w-5xl text-center">
          <p className="text-sm font-medium tracking-widest text-gold uppercase mb-4">Error 404</p>
          <h1 className="font-serif text-4xl md:text-6xl text-premium-purple leading-[1.1] mb-6">
            Page Not Found
          </h1>
          <p className="text-base md:text-lg text-deep-navy/70 leading-reading max-w-2xl mx-auto mb-10">
            The page you're looking for may have moved or no longer exists. You can return home, explore our most popular procedures below, or get in touch with the clinic directly.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-14">
            <Button asChild className="btn-gold border-none rounded-none px-8 py-6 text-base">
              <Link to="/">
                <Home className="w-5 h-5 mr-2" /> Back to Home
              </Link>
            </Button>
            <Button asChild variant="outline" className="rounded-none px-8 py-6 text-base border-premium-purple/40 text-premium-purple bg-transparent hover:bg-premium-purple/10 hover:text-premium-purple">
              <Link to="/contact">
                Contact Clinic <ArrowRight className="w-5 h-5 ml-2" />
              </Link>
            </Button>
          </div>

          <div className="border-t border-deep-navy/10 pt-10">
            <p className="text-sm font-medium tracking-widest text-gold uppercase mb-6">Popular Procedures</p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 max-w-3xl mx-auto">
              {POPULAR_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="block py-3 px-4 text-premium-purple hover:bg-premium-purple/5 border border-premium-purple/15 transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-deep-navy/70">
            <a href={`tel:${PHONE_DISPLAY.replace(/\s/g, "")}`} className="inline-flex items-center gap-2 hover:text-premium-purple">
              <Phone className="w-4 h-4" /> {PHONE_DISPLAY}
            </a>
            <span className="hidden sm:inline">·</span>
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="hover:text-premium-purple">
              WhatsApp the clinic
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFoundPage;
